// 輪盤

import Image from 'next/image';
import CampaignRouletteComponent from './CampaignRouletteComponent'; // 主要輪盤
import CampaignRouletteLogo from './CampaignRouletteLogo';

const CampaignRoulette = ({ roulettes, rotateAngle, handleStopSpin }) => {
    return (
        <div className="z-[0] mx-auto relative aspect-[1/1] usx:w-[85%] ">
            {/* logo + 特效 */}
            <CampaignRouletteLogo />

            <div className="rounded-b-[50%] w-[177%] aspect-[1/1] absolute bottom-0 left-[50%] translate-x-[-50%] overflow-hidden">
                <div className="img-box after:content-none w-full h-full z-[1]">
                    {/* 主要轉盤 */}
                    <CampaignRouletteComponent
                        roulettes={roulettes}
                        rotateAngle={rotateAngle}
                        handleStopSpin={handleStopSpin}
                    />

                    {/* 轉盤間隔線 */}
                    <div className="w-full h-full absolute bottom-[3px] left-0 rounded-[50%] z-[2] border-[10px] border-[#101C2C]" />
                    {/* 轉盤背景特效 */}
                    <Image
                        className="z-[0]"
                        width={400}
                        height={400}
                        src="/images/campaign/spin_bg.gif"
                        alt="bg"
                    />

                    {/* 轉盤指針 */}
                    <Image
                        className="!z-[4]"
                        width={400}
                        height={400}
                        src="/images/campaign/spin_circle.svg"
                        alt="bg"
                    />
                </div>
            </div>
        </div>
    );
};

export default CampaignRoulette;
